const getYesNoEnums = () => {
    return YesNoEnums;
};

let YesNoEnums = {
    Yes: 1,
    No: 2,

}

let AllergicStatusEnums = {
    PatientIsAllergic: 1,
    PatientIsNotAllergic: 2,
    PatientNotAddedAllergic: 3,
}

let AllergicTypesEnums = {
    SpecificDrugAllergy: 1,
    ClassDrugAllergy: 2,
    EnviromentalAllergy : 4,
    FoodAllergy : 3
}

const getAllergicStatusEnums = () => {
    return AllergicStatusEnums
}

let GenderEnums = { 
    Male: 1,
    Female: 2,
}

const getGenderEnums = () => {
    return GenderEnums
}

const geSmokingStatus = () => {
    return SmokingStatus;
};

let SmokingStatus = {
    NonSmoker: 1,
    CurrentSmoker: 2,
    ExSmoker:3
}


const getDateList = () => {
    return DateList;
};

let DateList = {
    Day: 1,
    Month: 2,
    Year: 3
}

const getSmearResult= () => {
    return SmearResult
}

let SmearResult = {
    Positive: 1,
    Negative: 2
}
let mainHealthQuestionnaireScreenEnums={
    submit:1
}
const getmainHealthQuestionnaireScreenEnums = () => {
    return mainHealthQuestionnaireScreenEnums
}
let medicationStatusEnums = {
    Taking: 1,
    Unknown:4
}
let saveResultEnums = {
    Sucess: 1,
    Failure : 2
}
const getSaveResultEnums = () => {
    return saveResultEnums
}

const getmedicationStatusEnums = () => {
    return medicationStatusEnums
}
//AllergicTypesEnums
const getAllergicTypesEnums = () => {
    return AllergicTypesEnums
}
let WizardEnums = {
    Screening: 1,
    MedicalHistory: 2,
}
const getWizardEnums = () => {
    return WizardEnums
}
export { getYesNoEnums, geSmokingStatus, getDateList, getAllergicStatusEnums, getGenderEnums, getSmearResult, getmainHealthQuestionnaireScreenEnums, getmedicationStatusEnums, getAllergicTypesEnums, getWizardEnums, getSaveResultEnums };